import {
  FlyoutOnboardingSectionName,
  type CheckAllCompletedParams,
} from '../types'

export const checkAllCompleted = ({
  pageMarker,
  page,
  isManaged,
}: CheckAllCompletedParams) => {
  if (page === FlyoutOnboardingSectionName.LABRA_PARTNER_DETAILS) {
    return isManaged || pageMarker.page2
  } else if (page === FlyoutOnboardingSectionName.CLOUD_SETTINGS) {
    return pageMarker.page1
  }
}
